var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRating1Dark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#616161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#312f2f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    y1: 1,
    y2: 0,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9207",
    "data-name": "Group 9207",
    transform: "translate(-3249 -10364)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_439",
    "data-name": "Ellipse 439",
    cx: 37,
    cy: 37,
    r: 37,
    transform: "translate(3249 10364)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_444",
    "data-name": "Ellipse 444",
    cx: 34,
    cy: 34,
    r: 34,
    transform: "translate(3252 10367)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9171",
    "data-name": "Group 9171",
    transform: "translate(3264.769 10388.593)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8882",
    "data-name": "Path 8882",
    d: "M.745,0A.708.708,0,0,0,.53,1.394,11.733,11.733,0,0,1,5.817,4.408a5.992,5.992,0,1,0,9.375,4.945C15.193,1.339,3.8.171.745,0",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8883",
    "data-name": "Path 8883",
    d: "M156.8,0c-3.053.169-14.448,1.337-14.448,9.352a5.992,5.992,0,1,0,9.375-4.945,11.734,11.734,0,0,1,5.288-3.014A.708.708,0,0,0,156.8,0",
    transform: "translate(-114.114 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8884",
    "data-name": "Path 8884",
    d: "M71.28,126.658a1.692,1.692,0,0,1-1.434-.79,10.96,10.96,0,0,0-8.877-4.708,11.281,11.281,0,0,0-8.9,4.736,1.693,1.693,0,0,1-2.832-1.857,14.729,14.729,0,0,1,11.727-6.266,14.391,14.391,0,0,1,11.745,6.294,1.694,1.694,0,0,1-1.434,2.591",
    transform: "translate(-39.254 -94.411)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRating1Dark);
export default __webpack_public_path__ + "static/media/rating_1_dark.d71435778bd5f73c3dc1db5cce5dbd98.svg";
export { ForwardRef as ReactComponent };